import { RootState } from '../index';

const getActiveStep = (state: RootState) => state.commissionsReducer.activeStep;

const getSelectedCommissionPlan = (state: RootState) => state.commissionsReducer.selectedCommissionsPlan;

const getCommissionPlans = (state: RootState) => state.commissionsReducer.commissionPlans;

const getToggleDeleteDialog = (state: RootState) => state.commissionsReducer.toggleDeleteDialog;

const getMemberEmails = (state: RootState) => state.commissionsReducer.memberEmails;

const getCommissionMode = (state: RootState) => state.commissionsReducer.commissionMode;

const getIsOpenAssignMembersNav = (state: RootState) => state.commissionsReducer.isOpenAssignMembersNav;

const getCommissionsSummary = (state: RootState) => state.commissionsReducer.commissionsSummary;

const getCommissionView = (state: RootState) => state.commissionsReducer.commissionView;

const getTableCommissionView = (state: RootState) => state.commissionsReducer.tableCommissionView;

const getIsOpenTeamCommissionsNav = (state: RootState) => state.commissionsReducer.isOpenTeamCommissionsNav;

const getSelectedTeam = (state: RootState) => state.commissionsReducer.selectedTeam;

const getCommissionTeams = (state: RootState) => state.commissionsReducer.commissionTeams;

const getIsOpenDeleteTeamDialog = (state: RootState) => state.commissionsReducer.isOpenDeleteTeamDialog;

const getSelectedProduct = (state: RootState) => state.commissionsReducer.selectedProduct;

export {
  getActiveStep,
  getSelectedCommissionPlan,
  getCommissionPlans,
  getToggleDeleteDialog,
  getMemberEmails,
  getCommissionMode,
  getIsOpenAssignMembersNav,
  getCommissionsSummary,
  getCommissionView,
  getTableCommissionView,
  getIsOpenTeamCommissionsNav,
  getSelectedTeam,
  getCommissionTeams,
  getIsOpenDeleteTeamDialog,
  getSelectedProduct,
};
